import { render, staticRenderFns } from "./FormaIngresso.vue?vue&type=template&id=7c6a5dbe"
import script from "./FormaIngresso.vue?vue&type=script&lang=js"
export * from "./FormaIngresso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports